import navlist from "../layout/leftnav.json"
let list = navlist.nav
// 处理json路由信息
export const getNav = function () {
  let routes = []
  for (const key in list) {
    let father = list[key]
    if(father.child && father.child.length){
      for (let i = 0; i < father.child.length; i++) {
        let son = father.child[i]
        let route = {
          path: son.path,
          name: son.name,
          meta: {...son.meta, fPath: father.path},
          component: () => import(`../views${son.path}.vue`)
        }
        routes.push(route)
      }
    }else{
      let { path, meta, redirect } = father
      let obj = {
        path,
        redirect,
        meta: {...meta, fPath: path },
        children: []
      }
      if(path) obj.component = () => import(`../views${path}.vue`)
      routes.push(obj)
    }
  }
  return routes
}